var render = function render(){var _vm=this,_c=_vm._self._c;return _c('area-container',[_c('area-nav',{attrs:{"links":_vm.links}}),_c('area-content',{staticClass:"layout"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }